import type { MatrixExceptionDateRange } from './resolveMatrixExceptionDateRanges';

/** Compact day/month labels for matrix drawer period summaries. */
export const formatMatrixExceptionRangeLabel = (
  range: MatrixExceptionDateRange,
  locale: string,
): string => {
  const start = new Date(`${range.startDate}T12:00:00`);
  const end = new Date(`${range.endDate}T12:00:00`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return range.startDate === range.endDate
      ? range.startDate
      : `${range.startDate} – ${range.endDate}`;
  }

  const formatDayMonth = (date: Date) =>
    new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' }).format(date);

  if (range.startDate === range.endDate) {
    return formatDayMonth(start);
  }

  return `${formatDayMonth(start)} – ${formatDayMonth(end)}`;
};
